"use client";
import { useState } from "react";
import SignUpModal from "../components/SignUpModal";

export default function AdminWelcome() {
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);

  return (
    <div className="bg-[#111827] text-white overflow-hidden relative min-h-screen">
      <main className="relative flex flex-col items-center justify-center text-center h-screen py-16 z-10">
        
        {/* Admin Console Header with Icon */}
        <div className="absolute md:top-[28%] top-[18%] flex flex-col items-center gap-6">
          {/* Admin Shield Icon with Advanced Effects */}
          <div className="relative group">
            {/* Outer glow ring */}
            <div className="absolute -inset-6 bg-gradient-to-r from-[#CB6CE6] via-[#6B21A8] to-[#CB6CE6] rounded-full opacity-30 blur-2xl animate-pulse"></div>
            
            {/* Rotating border ring - made very thin */}
            <div className="absolute -inset-2 border border-transparent bg-gradient-to-r from-[#CB6CE6]/30 via-[#6B21A8]/30 to-[#CB6CE6]/30 rounded-full animate-spin" style={{animation: 'spin 8s linear infinite', borderWidth: '1px'}}></div>
            <div className="absolute -inset-2 border border-slate-800/50 rounded-full" style={{borderWidth: '1px'}}></div>
            
            {/* Main admin icon container */}
            <div className="relative bg-gradient-to-br from-slate-800 to-slate-900 p-6 rounded-full border border-slate-700 scale-110 transition-all duration-500">
              {/* Phoebe Logo */}
              <img
                src="/phoebe-logo.png"
                alt="Phoebe Logo"
                className="w-8 h-8 object-contain drop-shadow-2xl"
              />
              
              {/* Inner pulse effect */}
              <div className="absolute inset-3 bg-[#CB6CE6]/20 rounded-full animate-ping"></div>
            </div>
            
            {/* Floating data indicators */}
            
          </div>
        </div>
        
        {/* Enhanced Admin Title */}
        <div className="absolute md:top-[40%] top-[28%] px-4 w-full">
          <div className="mb-4">
            <h1 className="md:text-5xl text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#CB6CE6] via-white to-[#6B21A8] leading-tight tracking-tight">
              Admin Console
            </h1>
            <div className="md:text-xl text-lg font-bold text-slate-300 mt-2 tracking-wider">
              Management Portal
            </div>
          </div>
          
          {/* Admin Description */}
          <p className="md:text-lg text-base text-slate-400 max-w-2xl mx-auto leading-relaxed">
            Access your comprehensive administrative dashboard. 
            <span className="text-[#CB6CE6] font-semibold"> Monitor systems</span>, 
            <span className="text-[#6B21A8] font-semibold"> manage users</span>, and 
            <span className="text-[#CB6CE6] font-semibold"> control operations</span>.
          </p>
        </div>
        
        {/* Enhanced Modern Admin Login CTA */}
        <div className="absolute md:top-[65%] top-[55%]">
          <button 
            onClick={() => setIsSignUpModalOpen(true)}
            className="group relative bg-gradient-to-r from-slate-900/80 to-slate-800/80 backdrop-blur-sm text-white md:px-8 px-6 py-3 rounded-2xl font-semibold text-base border border-slate-700/50 hover:border-[#CB6CE6]/50 transform hover:scale-105 transition-all duration-300 flex items-center overflow-hidden shadow-lg hover:shadow-[#CB6CE6]/20 hover:shadow-2xl"
          >
              {/* Background gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#CB6CE6]/0 via-[#CB6CE6]/5 to-[#6B21A8]/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
              
              {/* Button content */}
              <span className="relative z-10 flex items-center">
                <svg
                  className="w-4 h-4 mr-3 opacity-60 group-hover:opacity-100 transition-opacity duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 12H9v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-6.5C3 7.61 3.61 7 4.375 7H6" 
                  />
                </svg>
                <span className="tracking-wide">Admin Access</span>
                <svg
                  className="w-4 h-4 ml-3 group-hover:translate-x-1 transition-transform duration-300 opacity-60 group-hover:opacity-100"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    d="M13 7l5 5m0 0l-5 5m5-5H6" 
                  />
                </svg>
              </span>
              
              {/* Subtle shine effect */}
              <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full bg-gradient-to-r from-transparent via-white/5 to-transparent transition-transform duration-700 ease-out"></div>
            </button>
        </div>
        
        {/* Admin Dashboard Preview */}
        <div className="absolute bottom-0 md:w-[45%] w-[90%] opacity-80">
          <div className="relative">
            {/* Background glow for the geometric image */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#CB6CE6]/20 to-transparent blur-2xl"></div>
            <img
              src="/GeometricVolumePhoebe.png"
              alt="Geometric Volume Visualization"
              className="w-full block relative z-10 filter drop-shadow-2xl"
            />
          </div>
        </div>
      </main>

      {/* Sign Up Modal */}
      <SignUpModal 
        isOpen={isSignUpModalOpen} 
        onClose={() => setIsSignUpModalOpen(false)} 
      />
    </div>
  );
}